<!--
    REV-22007 — the workspace's file re-import (Pure View). No `<p>` anywhere: the app's global
    `#global-modal-placeholder p` rule centres and greys modal paragraphs (see erp-sync).

    Selector contract: tests bind to `data-testid` / `data-state`, never to classes or prose.
-->
<div class="erp-file-import" [class.erp-file-import--overlay]="overlay" data-testid="erp-file-import" [attr.data-state]="state">
    <div class="erp-file-import__card" role="dialog" aria-modal="true" [attr.aria-label]="'abcp.fileImport.dialog.title' | i18next">
        <div class="erp-file-import__head">
            <h2 class="erp-file-import__title">{{ 'abcp.fileImport.dialog.title' | i18next }}</h2>
            <ham-button
                class="erp-file-import__close"
                data-testid="erp-file-import-close"
                variant="transparent"
                size="xs"
                icon="assets/hamIcons/x.svg"
                [hideText]="true"
                [disabled]="importing"
                (buttonClick)="onClose()"
            ></ham-button>
        </div>

        <div class="erp-file-import__body">
            <div class="erp-file-import__lead">{{ 'abcp.fileImport.dialog.lead' | i18next }}</div>
            <div class="erp-file-import__period" data-testid="erp-file-import-period" *ngIf="periodLabel">
                {{ 'abcp.fileImport.dialog.period' | i18next: { period: periodLabel } }}
            </div>

            <div class="erp-file-import__actions">
                <label class="erp-file-import__pick" [class.erp-file-import__pick--disabled]="isUploading || importing">
                    <input
                        type="file"
                        class="erp-file-import__input"
                        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        data-testid="erp-file-import-input"
                        [disabled]="isUploading || importing"
                        (change)="onFilePicked($event)"
                    />
                    <lucide-icon name="upload" [size]="14" aria-hidden="true"></lucide-icon>
                    {{ (isReady ? 'abcp.setup.accounting.fileReplace' : 'abcp.setup.accounting.filePick') | i18next }}
                </label>
                <ham-button
                    data-testid="erp-file-import-template"
                    variant="transparent"
                    size="sm"
                    icon="assets/hamIcons/file-lines-outline.svg"
                    (buttonClick)="onTemplate()"
                >
                    {{ 'abcp.setup.accounting.fileTemplate' | i18next }}
                </ham-button>
            </div>

            <div class="erp-file-import__busy" data-testid="erp-file-import-uploading" *ngIf="isUploading">
                <span class="erp-file-import__spinner" aria-hidden="true"></span>
                <span>{{ 'abcp.setup.accounting.fileUploading' | i18next }}</span>
            </div>

            <div class="erp-file-import__preview" data-testid="erp-file-import-preview" *ngIf="isReady && preview as file">
                <span class="erp-file-import__tick" aria-hidden="true">
                    <lucide-icon name="check" [size]="20"></lucide-icon>
                </span>
                <span class="erp-file-import__preview-text">
                    <strong class="erp-file-import__name" data-testid="erp-file-import-name">{{ file.fileName }}</strong>
                    <span class="erp-file-import__meta">
                        <span data-testid="erp-file-import-accounts">{{ 'abcp.setup.accounting.fileAccounts' | i18next: { count: file.accounts } }}</span>
                        ·
                        <span>{{ 'abcp.setup.accounting.fileDifference' | i18next: { difference: file.difference } }}</span>
                    </span>
                </span>
            </div>

            <div class="erp-file-import__warnings" data-testid="erp-file-import-warnings" *ngIf="isReady && (preview?.warnings?.length ?? 0) > 0">
                <div class="erp-file-import__warnings-title">{{ 'abcp.setup.accounting.fileWarnings' | i18next }}</div>
                <ul class="erp-file-import__list">
                    <li *ngFor="let warning of preview?.warnings; trackBy: trackByLine">{{ warning }}</li>
                </ul>
            </div>

            <!-- What the import does to the closing, said BEFORE the click: the accounts are replaced by
                 the file's balances, and the account ledger shows one synthetic line per balance. -->
            <div class="erp-file-import__note" data-testid="erp-file-import-note" *ngIf="isReady">
                {{ 'abcp.fileImport.dialog.replaceNote' | i18next }}
            </div>

            <div class="erp-file-import__refusal" data-testid="erp-file-import-refusal" role="alert" *ngIf="isRefused">
                <lucide-icon name="triangle-alert" [size]="16" aria-hidden="true"></lucide-icon>
                <div>
                    <div class="erp-file-import__refusal-lead">{{ refusalLead ?? ('abcp.setup.accounting.fileRefused' | i18next) }}</div>
                    <ul class="erp-file-import__list" *ngIf="refusalRows.length > 0">
                        <li data-testid="erp-file-import-refusal-row" *ngFor="let row of refusalRows; trackBy: trackByLine">{{ row }}</li>
                    </ul>
                </div>
            </div>

            <div class="erp-file-import__refusal erp-file-import__import-error" data-testid="erp-file-import-error" role="alert" *ngIf="importError">
                <lucide-icon name="triangle-alert" [size]="16" aria-hidden="true"></lucide-icon>
                <div class="erp-file-import__refusal-lead">{{ importError }}</div>
            </div>
        </div>

        <div class="erp-file-import__footer">
            <ham-button
                data-testid="erp-file-import-cancel"
                variant="white"
                [disabled]="importing"
                (buttonClick)="onClose()"
            >
                {{ 'abcp.fileImport.dialog.cancel' | i18next }}
            </ham-button>
            <ham-button
                data-testid="erp-file-import-confirm"
                variant="primary"
                icon="assets/hamIcons/rotate-outline.svg"
                [disabled]="!canConfirm"
                (buttonClick)="onConfirm()"
            >
                {{ 'abcp.fileImport.dialog.confirm' | i18next }}
            </ham-button>
        </div>
    </div>
</div>
